export default "__VITE_PUBLIC_ASSET__8875eacb__"